// extracted by mini-css-extract-plugin
export var CoverWrapper = "Cover-module--CoverWrapper--FUhMC";
export var CoverImgWrapper = "Cover-module--CoverImgWrapper--Duvl3";